function getView() {
  let DictCtxView = {
    model: "melhous.guide_item",
    form_action: ["edit", "add", "save"],
    table_action: ["edit", "add", "delete"],
    activeSearch: false,
    target: "melhous",
    autoSave: true,
    domain: [],
    fields: {
      section: {
        type: "selection",
        options: [
          { id: "hotel", name: "hotel" },
          { id: "nearby", name: "nearby" },
        ],
        translate: true,
        required: true,
      },
      title: { type: "char", required: true },
      description: { type: "text" },
      schedule: { type: "char" },
      link: { type: "char" },
      sequence: { type: "integer" },
    },
    list: [{ name: "section" }, { name: "title" }, { name: "schedule" }],
    form: [
      { name: "section" },
      { name: "title" },
      { name: "schedule" },
      { name: "link" },
      { name: "sequence" },
      { name: "description", colSpan: "md:col-span-2" },
    ],
  };

  return DictCtxView;
}

export default { ctxView: getView };
